import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './TrainingLink.scss';
import TrainingLink from './TrainingLink';
import {isNZLocale} from 'lib/PropertyUtils';
import {ConfigurationTemplateNames} from 'lib/SettingsUtil';

const mapStateToProps = (state, ownProps) => {
  const {settings: {miscellaneousTemplates} = {}} = state;
  const isNZ = isNZLocale();
  const templateName = isNZ ? ConfigurationTemplateNames.NZ_TRAINING_LINK
    : ConfigurationTemplateNames.AU_TRAINING_LINK;
  const link = miscellaneousTemplates
    ?.filter(template => templateName === template.name)
    ?.map(template => template.value)
    ?.[0]
    || '';

  return {
    ...ownProps,
    link,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const TrainingLinkContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TrainingLink);

export { TrainingLinkContainer, TrainingLink };

TrainingLinkContainer.propTypes = {
  className: PropTypes.string,
};
export default TrainingLinkContainer;